var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#FFF300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.735 5.3821C12.5437 4.95404 12.3666 4.10804 11.8772 3.9196C11.2472 3.67772 10.8585 5.26285 10.7657 5.66335H10.6717C10.5131 4.9771 10.3005 4.00397 9.54674 3.78797C9.19799 5.25329 9.91124 6.83335 10.5784 8.10179C11.2905 7.76091 11.6376 6.69553 11.7034 5.9446H11.7973L12.5477 8.19516C13.1512 8.02191 13.3611 7.42453 13.5787 6.88228C14.0467 5.71903 14.4394 4.28804 14.1412 3.0376C13.2412 3.29297 12.9667 4.58054 12.735 5.3821ZM3.73274 8.38304C4.53824 7.99829 4.92187 6.77991 5.04562 5.9446H5.13899C5.23461 6.34735 5.48943 7.38572 5.9923 7.4521C6.63355 7.53703 6.96937 6.11504 7.01437 5.66335H7.1083C7.31249 6.36929 7.52793 7.28785 8.2333 7.63266C8.4943 6.53916 8.18268 5.3731 7.78274 4.35047C7.6798 4.08779 7.46887 3.37847 7.10605 3.37847C6.51205 3.37847 6.17793 4.94447 6.07668 5.3821H5.9833L5.23293 3.13154C3.9133 3.76154 3.19668 7.11235 3.73274 8.38304ZM2.32593 9.50804C3.30468 13.7797 7.82211 16.2018 11.8912 14.3973C13.3665 13.7418 14.5515 12.57 15.2235 11.1022C15.3984 10.723 15.7421 10.0362 15.5419 9.53841C15.3422 9.04229 13.4072 9.85229 12.9234 10.0643C12.89 10.0791 12.8609 10.1021 12.8386 10.1311C12.8164 10.1601 12.8019 10.1942 12.7963 10.2303C12.7884 10.2818 12.7912 10.3344 12.8046 10.3847C12.818 10.4351 12.8417 10.4821 12.8741 10.5229C12.9065 10.5637 12.947 10.5973 12.9931 10.6217C13.0391 10.646 13.0897 10.6606 13.1417 10.6645L13.9539 10.7275C12.483 13.5749 8.50555 14.8338 5.70205 12.559C5.0743 12.05 4.51462 11.4453 4.13774 10.7275C3.95549 10.3805 3.78618 9.93666 3.4768 9.69816C3.17868 9.46978 2.72755 9.39104 2.32593 9.50804Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrin);
export default __webpack_public_path__ + "static/media/grin.8d6adb7b4619daec755e621134f40d3a.svg";
export { ForwardRef as ReactComponent };